import React from 'react';
import { Clock, Instagram, MapPin } from 'lucide-react';
import { whatsappHref, registrarCliqueWhatsApp } from '../../lib/origem';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#2a3c5c] text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-semibold mb-1">Eliane Forti Fernandes</h3>
            <h3 className="text-xl font-semibold mb-3">CRP: 06/216637</h3>
            <p className="text-gray-300">
              "Cuidar da saúde mental é abrir espaço para o autoconhecimento..."
            </p>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-4">Links Úteis</h3>
            <ul className="space-y-2">
              <li><a href="/privacidade" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">Política de Privacidade</a></li>
              <li><a href="/termos" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">Termos de Uso</a></li>
              <li><a href="https://www.instagram.com/efortipsi" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">Instagram</a></li>
              <li><a href="https://www.youtube.com/@efortipsi" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">YouTube</a></li>
              <li><a href="https://www.tiktok.com/@efortipsi" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">TikTok</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-4">Contato</h3>
            <ul className="space-y-2">
              <li className="flex items-start">
                <MapPin size={16} className="mr-2 mt-1 flex-shrink-0" />
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Av.+Dr.+Olindo+Dartora%2C+205+-+SALA+5+-+Jardim+Santo+Antonio%2C+Caieiras+-+SP%2C+07700-230"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white hover:underline"
                >
                  Av. Dr. Olindo Dartora, 205 - SALA 5 - Jardim Santo Antonio, Caieiras - SP, 07700-230
                </a>
              </li>
              <li className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="mr-2 w-4 h-4"
                  aria-hidden="true"
                >
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>
                <a href={whatsappHref()} onClick={() => registrarCliqueWhatsApp('rodape')} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">(11) 4441-4782</a>
              </li>
              <li className="flex items-center">
                <Clock size={16} className="mr-2 flex-shrink-0" />
                <span className="text-gray-300">Segunda a quinta, das 9h às 19h</span>
              </li>
              <li className="flex items-center gap-4 pt-2">
                <span className="text-gray-300">@efortipsi</span>
                <a href="https://www.instagram.com/efortipsi" target="_blank" rel="noopener noreferrer" aria-label="Instagram @efortipsi" className="text-gray-300 hover:text-white">
                  <Instagram size={20} />
                </a>
                <a href="https://www.youtube.com/@efortipsi" target="_blank" rel="noopener noreferrer" aria-label="YouTube @efortipsi" className="text-gray-300 hover:text-white">
                  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" aria-hidden="true">
                    <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31.6 31.6 0 0 0 0 12a31.6 31.6 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1A31.6 31.6 0 0 0 24 12a31.6 31.6 0 0 0-.5-5.8ZM9.6 15.6V8.4l6.3 3.6-6.3 3.6Z" />
                  </svg>
                </a>
                <a href="https://www.tiktok.com/@efortipsi" target="_blank" rel="noopener noreferrer" aria-label="TikTok @efortipsi" className="text-gray-300 hover:text-white">
                  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" aria-hidden="true">
                    <path d="M16.6 5.8A4.3 4.3 0 0 1 15.5 3h-3.1v12.4a2.6 2.6 0 1 1-2.6-2.6c.3 0 .5 0 .8.1V9.7a5.8 5.8 0 0 0-.8-.1 5.7 5.7 0 1 0 5.7 5.7V9a7.4 7.4 0 0 0 4.3 1.4V7.3a4.3 4.3 0 0 1-3.2-1.5Z" />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-600 text-center">
          <p className="text-gray-300 mb-2">{currentYear} Eliane Forti Fernandes. Todos os direitos reservados.</p>
          <p className="text-sm text-gray-500">Desenvolvido com ❤️ pelo <a href="https://portaldossites.com.br" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white">Portal dos Sites</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

